function* getColumns(columns, columnType) {
  for (const key of Object.keys(columns)) {
    const colType = columns[key].datatype;
    if (typeof columnType === "string") {
      if (colType === columnType)
        yield key;
    } else {
      if (JSON.stringify(colType) === JSON.stringify(columnType))
        yield key;
    }
  }
}

function* generate(columns, signature) {
  if (!Array.isArray(signature)) throw new Error(`A signature ${signature} must be an array`);
  if (signature.length === 0) return yield [];
  const [firstColumnType, ...restSignature] = signature;
  for (const firstColumn of getColumns(columns, firstColumnType)) {
    for (const restContext of generate(columns, restSignature)) {
      yield [firstColumn, ...restContext];
    }
  }
}

export default function generateContextBySignature(columns, signature) {
  return [...generate(columns, signature)];
}
